import { render, staticRenderFns } from "./RightsResult1.vue?vue&type=template&id=03146d46"
import script from "./RightsResult1.vue?vue&type=script&lang=js"
export * from "./RightsResult1.vue?vue&type=script&lang=js"
import style0 from "./RightsResult1.vue?vue&type=style&index=0&id=03146d46&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports